import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../common/components/DatePicker';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormsField from '../common/forms/ReduxFormsField';
import ReduxFormsDateTimeField from '../common/forms/ReduxFormsDateTimeField';
import cloneDeep from 'lodash/cloneDeep';
import TwoStepButton from '../common/components/TwoStepButton';
import moment from 'moment';

const validate = values => {
  let errors = {};
  if (!values.start_date) {
    errors.start_date = ['Start Date is required'];
  }

  if (!Number.isInteger(values.limit) || values.limit <= 0) {
    errors.limit = ['Limit must be a positive number'];
  } else if (values.limit > 100000) {
    errors.limit = ['Limit cannot exceed 100,000'];
  }

  return errors;
};

class EditClassForm extends Component {
  static propTypes = {
    ...formPropTypes,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);
    submitValues.start_date = submitValues.start_date.format('YYYY-MM-DD');

    return this.props.onSubmit(submitValues);
  };

  render() {
    const { handleSubmit, onCancel, onDelete, submitting } = this.props;
    const start_date = Date.parse(this.props.class.start_date);
    const today = Date.parse(moment().format('YYYY-MM-DD'));
    const canDelete = start_date >= today;

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div className="admin-paper__edit-content">
          <Field
            className="admin__publish-date"
            name="start_date"
            component={ReduxFormsDateTimeField}
            label="Start Date"
            required={true}
          >
            <DatePicker />
          </Field>
          <Field
            name="limit"
            component={ReduxFormsField}
            label="Maximum Number of Attendees"
            required={true}
            parse={value => Number(value.replace(/\D/g, ''))}
          >
            <input type="text" />
          </Field>
        </div>
        <div className="admin-paper__edit-content">
          <TwoStepButton label="Delete Class" disabled={!canDelete} onConfirm={onDelete} />
        </div>
        <div className="modal__actions">
          <div className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'editClassForm',
  validate,
})(EditClassForm);



// WEBPACK FOOTER //
// ./src/golf-schools/EditClassForm.js